<span [class]="'letter env-' + env()" [attr.title]="name()">{{ env() }}</span>
@if (showName()) {
    <span class="name">{{ name() }}</span>
}
<ng-content></ng-content>
